import React from 'react';
import MuiSearchIcon from '@mui/icons-material/Search';
import Typography from '../Typography/Typography';
import { styled } from '@mui/material/styles';
import { shouldForwardProp as muiShouldOverrideProp } from '@mui/system/createStyled';
import { translate } from '../../locales';
import Grid from '@mui/material/Grid';

// we should reduce the container size because the anchor has an almost invisible border
// so it might seem like the container is bigger than the anchor.
const anchorBorderSize = 2;

const NoOptionsMessageContent = styled('div', {
  shouldForwardProp: prop => prop !== 'sizeValue' && muiShouldOverrideProp(prop)
})(({ theme, sizeValue }) => ({
  color: theme.palette.text.secondary,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 200,
  marginLeft: '-1px',
  padding: theme.spacing(0, 2),
  width: sizeValue - anchorBorderSize
}));

const SearchIcon = styled(MuiSearchIcon)(({ theme }) => ({
  marginRight: theme.spacing(0.5),
  display: 'flex'
}));

const NoOptionsMessage = ({
  header,
  footer,
  sizeValue,
  customNoResult,
  className
}) => {
  const message = translate('select.noResults');

  return (
    <Grid data-qa-id="no-options-message-container">
      {header && <div data-qa-id="no-options-message-header">{header}</div>}
      <NoOptionsMessageContent className={className} sizeValue={sizeValue}>
        {customNoResult || (
          <>
            <div>
              <SearchIcon data-qa-id="no-options-message-icon" />
            </div>
            <Typography variant="body1" data-qa-id="no-options-message-text">
              {message}
            </Typography>
          </>
        )}
      </NoOptionsMessageContent>
      {footer && <div data-qa-id="no-options-message-footer">{footer}</div>}
    </Grid>
  );
};

export default NoOptionsMessage;
